import useChartOptions from '@/features/_shared/chart/hooks/options/useChartOptions';
import useSpotOptions from '@/features/_shared/chart/hooks/options/useSpotOptions';
import RegularChart from '@/features/_shared/chart/RegularChart';
import { generateMockSeries } from '@/test-utils/fixtures/chartSeries.mock';

const mockData = [generateMockSeries()];

const UnauthenticatedChart = () => {
  const { createOptions } = useSpotOptions(14);
  const { options: chartOptions } = useChartOptions(mockData, createOptions);
  return (
    <RegularChart
      chartSeries={mockData}
      error={false}
      height={14}
      loading={false}
      options={chartOptions}
      showLegend={false}
    />
  );
};
export default UnauthenticatedChart;
